define(['jquery'],
	function($) {
		var ERVCustomValidationSummary = function () {
			var self = this;
			self.$ervBody = $('#erv-body');

			self.errorAlreadyExists = function (label, $errors) {
				var exists = false;

				$errors.each(function () {
					if ($(this).text() === '"' + label + '"') {
						exists = true;
					}
				});

				return exists;
			}

			self.updateErrorsSummary = function(validator, $updateSingleInput, clear, singleUpdate){
				var $ul = self.$ervBody.find('.validation-summary-errors').first().find('ul[data-js="geterrorfieldlabels"]');

				if ($ul.length === 1) {
					if(clear === true || typeof (clear) === 'undefined') {
						$ul.find('li').remove();
					}

					if (singleUpdate) {
						$ul.append($('<li>' + $updateSingleInput.parent().find('label').first().text() + '</li>'));
					} else if (validator != null) {
						for (var error of validator.errorList) {
							$ul.append($('<li data-errorkey="' + error.element.id + '" data-errormessage="' + error.message + '">' + error.message + '</li>'));
						}
					}
				}
			}

			self.createNewErrorsSummary = function(css, singleUpdate, $updateSingleInput, validator, $elementToPrependTo) {
				var specificCss = css != undefined && css.length > 0 ? css : '';

				var html = '<div class="validation-summary-errors ' + specificCss + '" data-valmsg-summary="true"><strong>' +
					window.ERV.ConfigurationSettings.Translation.ErrorSummaryHeader +
					'</strong><ul data-js="geterrorfieldlabels">';

				if (singleUpdate) {
					html += '<li>' + $updateSingleInput.parent().find('label').first().text() + '</li>';
				} else if (validator != null) {
					for (var error of validator.errorList) {
						html += "<li data-errorkey=\"" + error.element.id + "\" data-errormessage=\"" + error.message + "\">" + error.message + "</li>";
					}
				}

				html += '</ul></div>';

				if ($elementToPrependTo.attr('id') === 'booking-widget') {
					$elementToPrependTo.find('div.booking-content .fields').prepend(html);
				} else {
					$elementToPrependTo.prepend(html);
				}
			}
		}

		ERVCustomValidationSummary.prototype.updateErrorFieldsLabels = function (validator, $elementToPrependTo, $updateSingleInput, css, clear) {
			var self = this;
			var singleUpdate = $updateSingleInput != undefined && $updateSingleInput.length > 0;

			if (self.$ervBody.find('.validation-summary-errors').length > 0) {
				self.updateErrorsSummary(validator, $updateSingleInput, clear, singleUpdate);
			} else {
				self.createNewErrorsSummary(css, singleUpdate, $updateSingleInput, validator, $elementToPrependTo);
			}
		}

		ERVCustomValidationSummary.prototype.setErrorFieldLabels = function () {
			var self = this,
				$errorElements = self.$ervBody.find('[data-js="geterrorfieldlabels"] li');

			//jquery validation
			$errorElements.each(function () {
				var $error = $(this),
					errorKey = $error.data('errorkey'),
					label = '',
					hasSpecificMessage = false;

				if(!errorKey.length) {
					return;
				}
				
				var $element = null,
					$bookingWidget = self.$ervBody.find('form#booking-widget');

				if ($bookingWidget.length > 0) {
					var $container = $bookingWidget.find('.insurance-fields:not(.hide)');

					if ($container.length > 0) {
						$element = $container.find('#' + errorKey);
					} else {
						$element = $bookingWidget.find('#' + errorKey);
					}
				} else {
					$element = self.$ervBody.find('#' + errorKey + ':not(:disabled)');
				}

				if ($element.length > 0) {
					var $elementParent = $element.parents('.field'),
						$messageContainer = $elementParent.find('label[for="' + errorKey + '"]');

					if ($messageContainer.length > 0) {
						label = $messageContainer.first().text();
					} else {
						label = $elementParent.find('[data-messagefor="' + errorKey + '"]').data('heading');
					}

					if ($element.data('validationmessageelement') !== undefined) {
						var $validationMessageContainer = self.$ervBody.find('[data-messagefor="' + $element.data('validationmessageelement') + '"]');
						$validationMessageContainer.removeClass('hide');
						hasSpecificMessage = true;
					}
				} else {
					//if straight from backend
					$element = self.$ervBody.find('[data-messagefor="' + errorKey + '"]');
					if ($element.length > 0) {
						$element.removeClass('hide');
						hasSpecificMessage = true;
						label = $element.data('heading');
					} else {
						$element = self.$ervBody.find('[for="' + errorKey + '"]');
						label = $element.text();
					}
				}

				if (label === undefined) { return false; }

				if (label.length > 0 && !self.errorAlreadyExists(label, $errorElements)) {
					$error.text('"' + label.trim().replace("*", "") + '"');
						
					if (!$element.hasClass('custom-validation-message')) {
						$element.addClass('input-validation-error');
					}
				} else if(!hasSpecificMessage){
					$error.remove();
					$element.removeClass('input-validation-error');
				}
			});

			var $errorsAfterRemove = self.$ervBody.find('.validation-summary-errors li'),
				$visibleErrorMessages = self.$ervBody.find('.field-validation-error:visible');

			if ($errorsAfterRemove.length === 0 && $visibleErrorMessages.length === 0) {
				self.$ervBody.find('.validation-summary-errors').remove();
			}
		};

		return ERVCustomValidationSummary;
	});